import React, {Component} from "react";
import "./index.css";
import {Tooltip, Popover} from "antd";
import {connect} from "react-redux";
import data from './data.json'
import {DownloadOutlined, FilePdfOutlined} from "@ant-design/icons";

class PresentationDetail extends Component {


    state = {
        childSystems: [],
        subSystemName: "",
        introduction: "",
        dataId: null,
    }


    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const id = parseInt(params.get('id'));
        // const MenuIndex = params.get('selectMenuIndex');
        const detailData = data[id];
        this.setState({dataId: id,})
        // const childSystems = detailData.childSystems;
        // const subSystemName = detailData.subsystemName;
        const {introduction, subsystemName, childSystems} = detailData;
        this.setState({childSystems: childSystems, subSystemName: subsystemName, introduction: introduction})
    }

    _renderModules = (modules) => {
        // console.log('检查无法渲染模块错误', modules)
        return <div className="modules_box">
            {modules.map(module => {
                if (module.moduleUrl.includes('GXWBCPJY') && !module.moduleUrl.includes('124.16.188.131')) module.moduleUrl = `/lxyweb/kjweb/#/Map?token=${this.props.user.token}`
                if (module.moduleUrl.includes('ZDCL') && !module.moduleUrl.includes('ZDCLRW')) module.moduleUrl = `https://landv.aircas.ac.cn:10088/space/StationNetworkSurvey/#/login?token=${this.props.user.token}`
                if (module.moduleUrl.includes('ZZSJ')) module.moduleUrl = `https://landv.aircas.ac.cn:10088/GroundSharingsew/#/grounddatashare?token=${this.props.user.token}`
                if (module.moduleUrl.includes('ZNYGYY')) module.moduleUrl = `https://caplos.aircas.ac.cn/IrsaclWeb/static/home?token=${this.props.user.token}`
                if (module.moduleUrl.includes('SYJH')) module.moduleUrl = `https://landv.aircas.ac.cn:10088/space/JoinTheComprehensiveExperiment/#/WorkBench?token=${this.props.user.token}`
                if (module.moduleUrl.includes('GXWBCL')) module.moduleUrl = `/lxyweb/kjwebAdmin/#/Order/DJYOrder?token=${this.props.user.token}`
                if (module.moduleUrl.includes('https://caplos.aircas.ac.cn/#/DC') && !module.moduleUrl.includes('DCCPCX')) module.moduleUrl = `https://caplos.aircas.ac.cn/DC2?userToken=${this.props.user.token}&userName=${this.props.user.userName}&userId=${this.props.user.userId}`
                if (module.moduleUrl.includes('DCCPCX')) module.moduleUrl = `https://caplos.aircas.ac.cn/DC1/dcfz_display_web/?userToken=${this.props.user.token}&userName=${this.props.user.userName}&userId=${this.props.user.userId}`
                if (module.remarks !== "") return <Tooltip
                    title={module.remarks}><a>{module.moduleName}</a></Tooltip>
                return <a href={module.moduleUrl}>{module.moduleName}</a>
            })}
        </div>
    }
    handleBack = () => {
        this.props.history.goBack();  // 返回到上一个页面
    }
    // function handleBack() {
    //     history.push({
    //         pathname: '/Introduce',
    //         state: {index: parseInt(MenuIndex)}
    //     });
    // }
    render() {
        return <div className="pre_bg">
            <div className="pre_bg_image">
                <div className="pre_header">
                    <div className="pre_header_title_text">
                        陆地观测卫星共性应用支撑平台
                        <div
                            className="pre_header_title_en_text">{"Common application support platform for land observation satellite"}</div>
                    </div>
                </div>
                <div className="pre_detail_body">
                    <div className="pre_detail_header">
                        <div className="pre_detail_title">{this.state.subSystemName}</div>
                        <div className="return_button" onClick={this.handleBack}>返回</div>
                    </div>
                    <div className="pre_detail_introduction">{this.state.introduction}</div>
                    <div className="pre_detail_item_box">
                        {this.state.childSystems.map(item =>
                            <Popover placement="right" title="模块列表" trigger="click"
                                     content={() => this._renderModules(item.modules)}>
                                <div className="pre_detail_item">
                                    <div className="pre_detail_item_icon_box">
                                        <svg d="1740448677416" className="icon pre_detail_item_icon"
                                             viewBox="0 0 1024 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg" p-id="3267" width="128" height="128">
                                            <path
                                                d="M896.64 127.36c80.768 80.704 64.096 230.304-23.584 384.64 87.68 154.336 104.32 303.936 23.616 384.64-80.736 80.768-230.336 64.096-384.704-23.616-154.304 87.68-303.904 104.384-384.64 23.648-80.736-80.736-64.064-230.336 23.616-384.64-87.68-154.368-104.32-303.968-23.616-384.704 80.736-80.736 230.336-64.064 384.704 23.648 154.304-87.68 303.904-104.384 384.64-23.648z m-62.848 447.104l-5.76 8.32a1020.32 1020.32 0 0 1-112.384 132.864 1014.976 1014.976 0 0 1-141.216 118.176c118.688 59.84 225.28 69.28 276.992 17.6 51.68-51.712 42.24-158.304-17.6-276.96z m-643.616 0l-0.576 1.216c-59.328 118.176-68.512 224.224-17.024 275.744 51.712 51.68 158.304 42.24 276.96-17.6a1015.104 1015.104 0 0 1-141.184-118.176 1014.976 1014.976 0 0 1-118.176-141.216zM512 225.728l-0.896 0.544a930.944 930.944 0 0 0-157.504 127.296C302.304 404.896 259.392 458.88 225.76 512c33.6 53.12 76.544 107.104 127.84 158.4 51.296 51.296 105.28 94.208 158.4 127.84 53.12-33.6 107.104-76.544 158.4-127.84 51.296-51.296 94.208-105.28 127.84-158.4-33.6-53.12-76.544-107.104-127.84-158.4-51.296-51.296-105.28-94.208-158.4-127.84z m0 206.24a80 80 0 1 1 0 160 80 80 0 0 1 0-160zM172.576 172.576c-51.68 51.712-42.24 158.336 17.632 276.992a1012.064 1012.064 0 0 1 118.144-141.216 1014.976 1014.976 0 0 1 141.216-118.176c-118.656-59.84-225.28-69.28-276.992-17.6z m412.896 12.16l-11.04 5.44a1014.976 1014.976 0 0 1 141.216 118.176 1014.976 1014.976 0 0 1 118.144 141.184c59.872-118.656 69.312-225.28 17.6-276.96-50.048-50.08-151.68-42.784-265.92 12.16z"
                                                p-id="3268" fill="#18c6ee"></path>
                                        </svg>
                                    </div>
                                    <p className="child_system_name">{item.childSystemName}</p>
                                </div>
                            </Popover>
                        )}
                    </div>

                </div>
            </div>
        </div>
    }

}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(),
    user: state.userReducer.get("user").toJS(),
});
const mapDispatch = () => ({});

export default connect(mapState, mapDispatch)(PresentationDetail);